import { render, staticRenderFns } from "./GroupChat.vue?vue&type=template&id=3d33e675&scoped=true&"
import script from "./GroupChat.vue?vue&type=script&lang=js&"
export * from "./GroupChat.vue?vue&type=script&lang=js&"
import style0 from "./GroupChat.vue?vue&type=style&index=0&id=3d33e675&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33e675",
  null
  
)

export default component.exports